import { render, staticRenderFns } from "./DetailFleetTask.vue?vue&type=template&id=4ee7c6b6&scoped=true&"
import script from "./DetailFleetTask.vue?vue&type=script&lang=js&"
export * from "./DetailFleetTask.vue?vue&type=script&lang=js&"
import style0 from "./DetailFleetTask.vue?vue&type=style&index=0&id=4ee7c6b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee7c6b6",
  null
  
)

export default component.exports